import { useState, useEffect, useRef } from "react";
import { Text } from "../Text";
import { timeProgressBar } from "../../constants/constants";
import classes from './TimerProgressBar.module.css';
import { TimeProgress } from "../TimeProgress";
import { TimerClockIcon } from "../../assets/icons";
/**
 * @returns timerbar component
 * This component display a timer progress bar when the part to monolog question required an answer
 * Progress bar will be displayed for 120 seconds for capturing the answer
 * It also displays messages whenever the timer starts and 1 minute remaining the timer
 * Time duration i.e. 120 seconds and messages configured in constants.ts file
 */

const TimerProgressBar = ({ timerBarDuration = timeProgressBar.DURATION, showTime = false, endTime = 0, className = "", play = true, promptTimerMessage = 0 }) => {
  const [progress, setProgress] = useState(0);
  const timerMSg = useRef("");
  const timeStart = useRef("00:00");
  const percentageBar = useRef(0);

  // Code to calculate seconds to display in Sound check screen
  const toMMSS = (sec: any) => {
    const minutes = Math.floor(sec / 60).toString().padStart(2, '0');
    const remainingSeconds = (sec % 60).toString().padStart(2, '0');
    return `${minutes}:${remainingSeconds}`;
  }

  // Code to set time start and end for the timer
  useEffect(() => {
    if (!play) return;

    const interval = 100; // Update interval in milliseconds
    const totalTicks = timerBarDuration === 0 ? 0 : (timerBarDuration * 1000) / interval;
    let halfTicks = totalTicks / 20;
    let halfMin = halfTicks / 60;
    let halfSec = halfTicks % 60;
    let halfWayMessage = `${ halfMin >= 1 ? halfMin + ' minute' : ''}${halfSec > 0 ? ' ' + halfSec + ' seconds' : '' }`;
    if(timerBarDuration === 0 && showTime){
      timeStart.current = toMMSS(0);
    }
    let tick = 0;

    // Code to caluculate seconds to display in Sound check screen
    const timer = setInterval(() => {
      tick += 1;
      let percentage =  timerBarDuration === 0 ? 0 : (tick / totalTicks) * 100;
      percentageBar.current = percentage;
      // Code to animate the progress bar
      setProgress(percentage);

      if (tick >= totalTicks) {
        clearInterval(timer);
      }

      if (showTime) {
        if (tick % 10 === 0) {
          // Code to update time start and end for the timer when sound check starts
          timeStart.current = toMMSS(tick * interval / 1000);
        }
      } else if (!showTime) {
        // Code to display the time related messages
        if (percentage < 3) {
          timerMSg.current = timeProgressBar.YOUR_TIME_STARTS_NOW;
        } else if (percentage > 49 && percentage < 53) {
          timerMSg.current = `${halfWayMessage} left`;
        } else {
          timerMSg.current = "";
        }
      }

    }, interval);

    return () => clearInterval(timer); // Clean up interval on component unmount
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [timerBarDuration, play]);

  return (
    <div className={className}>
      {/* Time Progress component for the progress bar with start and end time */}
      <TimeProgress showTime={showTime} progress={progress} startTime={timeStart.current} endTime={toMMSS(endTime)} />
      {!showTime && percentageBar.current > 95 && percentageBar.current < 100 && promptTimerMessage <= 5 && promptTimerMessage >= 1 ? (
        <div className={classes.timeMsg}>
          <TimerClockIcon />
          <Text className={classes.timeMsgText} text={promptTimerMessage.toString()} fontWeight="medium" />
        </div>
      ) : (
        timerMSg.current !== "" && (
          <div className={classes.timeMsg}>
            <TimerClockIcon />
            <Text className={classes.timeMsgText} text={timerMSg.current} fontWeight="medium" />
          </div>
        )
      )}
    </div>
  );
};


export default TimerProgressBar;